import { render, staticRenderFns } from "./ArticleEdit.vue?vue&type=template&id=2df409ea&"
import script from "./ArticleEdit.vue?vue&type=script&lang=ts&"
export * from "./ArticleEdit.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports